
import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, Paper, CircularProgress } from '@mui/material';

interface TermsOfUseModalProps {
  isOpen: boolean;
  version: string;
  onAccept: () => void;
}

const TermsOfUseModal: React.FC<TermsOfUseModalProps> = ({ isOpen, version, onAccept }) => {
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    fetch(`/assets/legal/tandc-${version}.html`)
      .then(res => res.text())
      .then(html => setHtmlContent(html))
      .finally(() => setLoading(false));
  }, [isOpen, version]);

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal
      open={isOpen}
      aria-labelledby="terms-of-use-title"
      aria-describedby="terms-of-use-description"
    >
      <Paper sx={style}>
        <Typography id="terms-of-use-title" variant="h6" component="h2">
          Terms of Use
        </Typography>
        <Box
          id="terms-of-use-description"
          sx={{ mt: 2, mb: 3, maxHeight: '60vh', overflowY: 'auto' }}
        >
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <Box dangerouslySetInnerHTML={{ __html: htmlContent }} />
          )}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" color="primary" onClick={onAccept} disabled={loading}>
            Accept
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export default TermsOfUseModal;
